import { Component } from 'preact';
import { useEffect } from 'preact/hooks';
import { Portal } from '@/components';
import { getCookie, addClass, removeClass, getPageUrl, getStrParam } from '@/utils';
import { useAdvanced, useFormProps } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';

class LandingPageIframe extends Component {
	shouldComponentUpdate() {
		return false;
	}
	render(props) {
		return <iframe {...props} />;
	}
}

export default function LandingPage() {
	const { formKey } = useFormProps();
	const advanced = useAdvanced();
	const { hideLandingPageForm, actions } = useFormStore();

	const publicSrvBody = document.querySelector('#publicSurveyBody')
		? '#publicSurveyBody'
		: 'body';
	const iframeURL =
		getStrParam('mail_url', getPageUrl()) ||
		getStrParam('mail_url', getCookie(formKey)) ||
		advanced.landingspageUrl ||
		'';
	const theme = advanced.landingspageTheme ?? 'dark';

	useEffect(() => {
		if (iframeURL) {
			addClass([document.querySelector(publicSrvBody)], 'customBackground');
			addClass([document.querySelector(publicSrvBody)], theme);

			if (advanced.landingspageTransparency) {
				addClass([document.querySelector(publicSrvBody)], 'transparent');
			}
		}
	}, [advanced.landingspageTransparency, iframeURL, theme, publicSrvBody]);

	if (
		!advanced.enableCustomBackground ||
		!iframeURL.match(
			/^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.​\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[​6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1​,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00​a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u​00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/gi
		)
	) {
		return null;
	}

	return (
		<Portal into={document.querySelector(publicSrvBody)}>
			<div>
				<LandingPageIframe
					src={iframeURL}
					id="mailUrl"
					className="bg__mailing_Iframe"
					style={hideLandingPageForm ? { zIndex: 1 } : {}}
				/>
				{!hideLandingPageForm && (
					<button
						type="button"
						className={`close_custom_bg ${theme}`}
						onClick={() => {
							actions.dispatch({
								type: 'set_hide_landingspage_form'
							});
							removeClass([document.querySelector(publicSrvBody)], theme);
						}}
					>
						{advanced.landingspageClose && (
							<span className={`close_custom_bg_lbl ${theme}`}>
								{advanced.landingspageClose}
							</span>
						)}
					</button>
				)}
			</div>
		</Portal>
	);
}
